import * as React from "react";
const SvgClearSort = (props) => /* @__PURE__ */ React.createElement("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React.createElement("path", {
	fillRule: "evenodd",
	clipRule: "evenodd",
	d: "M36.4884 26.5789C37.1705 27.2538 37.1705 28.3568 36.4884 29.0389H36.4957L36.1149 29.4197L33.4031 27.2042L34.0284 26.5789C34.7033 25.8968 35.8063 25.9041 36.4884 26.5789ZM30.0373 24.4545V5.74521C30.0373 4.78008 29.2608 4.00363 28.2957 4.00363C27.3306 4.00363 26.5541 4.78008 26.5541 5.74521V21.6089L30.0373 24.4545ZM14.4459 11.7169V9.94679L18.437 13.9379C19.1191 14.62 20.2221 14.62 20.897 13.9379C21.5719 13.2558 21.5791 12.1528 20.897 11.4779L13.9452 4.51159C13.2631 3.82947 12.16 3.82947 11.4852 4.51159L8.81029 7.1837C9.03527 7.3208 9.25351 7.47496 9.46331 7.64636L14.4459 11.7169ZM4.75097 11.2388L4.51159 11.4779C3.82947 12.16 3.82947 13.2631 4.51159 13.9379C5.19371 14.6128 6.29671 14.62 6.97158 13.9379L7.45863 13.4509L4.75097 11.2388ZM10.9627 16.3136V34.7716C10.9627 35.7367 11.7392 36.5132 12.7043 36.5132C13.6694 36.5132 14.4459 35.7367 14.4459 34.7716V19.1592L10.9627 16.3136ZM32.0189 33.5157L29.5293 36.0052C28.8545 36.6874 27.7515 36.6874 27.0693 36.0052L20.103 29.0389C19.4209 28.364 19.4281 27.261 20.103 26.5789C20.7779 25.8968 21.8809 25.8968 22.563 26.5789L26.5541 30.57V29.0511L32.0189 33.5157Z"
}), /* @__PURE__ */ React.createElement("rect", {
	x: 4.15271,
	y: 5.10822,
	width: 45,
	height: 2.97881,
	rx: 1.4894,
	transform: "rotate(39.2475 4.15271 5.10822)"
}));
export default SvgClearSort;
